//export a logger function that will be used to log messages
const logger = (debug: boolean, level: string| null, message: string) => {

    if (debug) {
      switch (level) {
        case "info":
          console.info(message);
          break;
        case "warn":
          console.warn(message);
          break;
        case "error":
          console.error(message);
          break;
        default:
          console.trace(message);
          break;
      }
    }
  }

export {logger};